import React, { Component } from 'react';
import '../../Style/App.css';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';

class Footer extends Component {
    // constructor(props) {
    //   super(props);
    //   // State is in reducers
    // }
  
    buildingFunction = ()=> {
      return [];
    }
  
  
  
    render() {
      // const someVar = this.buildingFunction(); 
  
      return (
        <div className="Footer">
          
          {/* <FontAwesomeIcon onClick={this.props.togglePresentationMode} icon={this.props.presentationMode?"compress-arrows-alt":"expand-arrows-alt"}/>
          <FontAwesomeIcon onClick={this.props.toggleNightMode} icon={this.props.nightMode?"lightbulb":"moon"}/> */}
          <div className="session"><div className={this.props.isConnected?"open":"close"}></div></div>
        </div>
      );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {  
      presentationMode : state.appReducer.presentationMode,
      nightMode : state.appReducer.nightMode, 
      isConnected : state.apiReducer.isConnected,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      togglePresentationMode: (props) => dispatch(repositoryActions.togglePresentationMode(props)),
      toggleNightMode: (props) => dispatch(repositoryActions.toggleNightMode(props)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(Footer);
  